import {AlgorithmExplanation} from "@/components/MSPaint/AlgorithmInstruction.tsx";
import {Paint} from "@/components/MSPaint/MSPaint.tsx";

export function MspaintPage() {
    return (
        <div className="min-h-screen bg-gray-100 p-8">
            <h1 className="text-3xl font-bold text-center mb-8">Paint with Flood Fill Algorithm</h1>
            <div className="flex gap-8 max-w-7xl mx-auto">
                <Paint />
                <AlgorithmExplanation />
            </div>
        </div>
    );

}